import React from "react";

// @material-ui/core components
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
// core components
import styles from "../../assets/jss/material-dashboard-react/components/tableStyle.js";

import { KsUtility } from "../../../Core/index";
import { Column } from "material-table";
import type { ReactNode } from "react";

import { Card, CardHeader, CustomLoader } from '../../../Control';
import { CardContent } from '@material-ui/core'
type TableClassKey =
  | "warningTableHeader"
  | "primaryTableHeader"
  | "dangerTableHeader"
  | "successTableHeader"
  | "infoTableHeader"
  | "roseTableHeader"
  | "grayTableHeader"
  | "table"
  | "tableHeadCell"
  | "tableCell"
  | "tableResponsive"
  | "tableHeadRow"
  | "tableBodyRow";

const useStyles = makeStyles<Theme, {}, TableClassKey>((theme: Theme) =>
  createStyles(styles(theme) as Parameters<typeof createStyles>[0])
);


export interface CustomTableProps<T extends object = Record<string, unknown>> {
  columns: Column<T>[] | unknown[];
  data?: T[] | unknown;
  IsLoading?: boolean;
  tableHeaderColor?: "warning" | "primary" | "danger" | "success" | "info" | "rose" | "gray";
  title?: string;
}
export default function CustomTable<T extends object>(props: CustomTableProps<T>) {
  const classes = useStyles();
  const { columns, data, tableHeaderColor, IsLoading, title } = props;
  const tableHeaderClassKey: TableClassKey = `${tableHeaderColor || "gray"}TableHeader` as TableClassKey;

  const columnList = (columns || []) as Column<T>[];
  var columnTitles = columnList.map(i => i?.title);
  var dataListShowable: ReactNode[][] = [];
  if (Array.isArray(data) && columnList.length) {
    (data as T[]).forEach((row, i) => {
      var tempValues: ReactNode[] = [];
      columnList.forEach((clm: Column<T>) => {
        if (typeof clm?.render === 'function') {
          tempValues.push(clm.render(row, 'row') as ReactNode);
        } else {
          tempValues.push(KsUtility.GetValueByKey(row, (clm?.field as string) || (clm?.title as string) || "") as ReactNode);
        }
      });
      dataListShowable.push(tempValues);
    });
  }

  if (IsLoading) {
    return (
      <CustomLoader />
    )
  }

  return (
    <div>
      <Card>
        {
          title && <CardHeader color="success">
            {title}
          </CardHeader>
        }

        <CardContent>
          <div className={classes.tableResponsive}>
            <Table className={classes.table}>
              {columns !== undefined ? (
                <TableHead className={classes[tableHeaderClassKey]}>
                  <TableRow className={classes.tableHeadRow}>
                    {columnTitles.map((prop, key) => {
                      var hColumn = columnList[key];
                      return (
                        <TableCell
                          className={classes.tableCell + " " + classes.tableHeadCell}
                          key={key}
                          align={hColumn?.align || "inherit"}
                        >
                          {prop}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                </TableHead>
              ) : null}
              <TableBody>
                {dataListShowable.map((prop, key) => {
                  return (
                    <TableRow key={key} className={classes.tableBodyRow}>
                      {prop.map((cell: ReactNode, key: number) => {
                        var hColumn = columnList[key];
                        return (
                          <TableCell className={classes.tableCell} key={key} align={hColumn?.align || "inherit"}>
                            {cell}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
